import moment from "moment";
import { useEffect, useState } from 'react';
import { mostraAlertaError, mostraAlertaOk } from "../../../../componentes/alerts/sweetAlert";
import { AxiosPrivado } from "../../../../componentes/axios/Axios";
import MetodosPagos from "../../../../componentes/metodos/MetodosPagos";
import ModalBootstrap from "../../../../componentes/modal/ModalBootstrap";
import { IngresosEgresosGuardar, IngresosEgresosListar } from '../../../../configuracion/apiUrls';
import { formatoMoneda } from "../../../../configuracion/validaciones";

const ModalEgreso = ({ ActualizarLista, setListaIngresosEgresos, usuario, cajaId, verificarYCargarCaja }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [efectivo, setEfectivo] = useState(0);
    const [pos, setPos] = useState(0);
    const [transferencias, setTransferencias] = useState(0);
    const [montosPos, setMontosPos] = useState({});
    const [referenciasPos, setReferenciasPos] = useState({});
    const [erroresReferenciaPos, setErroresReferenciaPos] = useState({});
    const [montosTransferencia, setMontosTransferencia] = useState({});
    const [referenciasTransferencia, setReferenciasTransferencia] = useState({});
    const [erroresReferenciaTransferencia, setErroresReferenciaTransferencia] = useState({});

    const [formulario, setFormulario] = useState({
        fecha: moment().toISOString(),
        tipo: 'Egresos',
        notas: '',
    });

    useEffect(() => {
        if (modalIsOpen) {
            verificarYCargarCaja();
            setFormulario({
                fecha: moment().toISOString(),
                tipo: 'Egresos',
                notas: '',
            });
            limpiarDatosPago();
        }
    }, [modalIsOpen]);

    const limpiarDatosPago = () => {
        setEfectivo(0);
        setPos(0);
        setTransferencias(0);
        setMontosPos({});
        setReferenciasPos({});
        setErroresReferenciaPos({});
        setMontosTransferencia({});
        setReferenciasTransferencia({});
        setErroresReferenciaTransferencia({});
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormulario(prev => ({ ...prev, [id]: value }));
    };

    const generarListaTransferencias = () => {
        return Object.keys(montosTransferencia)
            .filter(id => parseFloat(montosTransferencia[id]) > 0)
            .map(id => ({
                monto: parseFloat(montosTransferencia[id]),
                referencia: referenciasTransferencia[id],
                cuentaId: parseInt(id)
            }));
    };

    const generarListaPos = () => {
        return Object.keys(montosPos)
            .filter(id => parseFloat(montosPos[id]) > 0)
            .map(id => ({
                monto: parseFloat(montosPos[id]),
                referencia: referenciasPos[id],
                posId: parseInt(id)
            }));
    };

    const validarReferencias = () => {
        const hayErrorPos = Object.values(erroresReferenciaPos).some(e => e === true);
        const hayErrorTrans = Object.values(erroresReferenciaTransferencia).some(e => e === true);
        if (hayErrorPos || hayErrorTrans) {
            mostraAlertaError("Hay referencias inválidas. Verifique los campos marcados.", "Error de validación");
            return false;
        }
        return true;
    };

    const handleGuardar = async () => {
        if (!cajaId) return mostraAlertaError("La caja no está abierta.", "Error");

        const totalRecibido = parseFloat(efectivo || 0) + pos + transferencias;

        if (totalRecibido <= 0) {
            return mostraAlertaError("El monto debe ser mayor a cero.", "Monto inválido");
        }
        if (formulario.notas.length < 5) {
            return mostraAlertaError("Escriba un detalle (mínimo 5 caracteres).", "Detalle Obligatorio");
        }
        if (!validarReferencias()) return;

        const payload = {
            ingreso: {
                fecha: formulario.fecha,
                tipo: formulario.tipo,
                notas: formulario.notas,
                monto: totalRecibido,
                usuarioId: usuario.id,
                cajaId: cajaId
            },
            pago: {
                pago: totalRecibido,
                estado: "Completada",
                recibido: totalRecibido,
                cajaId: cajaId,
                fecha: formulario.fecha,
                documento: 'G',
                efectivo: parseFloat(efectivo) > 0 ? [{ monto: parseFloat(efectivo) }] : [],
                transferencia: generarListaTransferencias(),
                tarjeta: generarListaPos()
            }
        };

        setIsLoading(true);
        try {
            await AxiosPrivado.post(IngresosEgresosGuardar, payload);
            mostraAlertaOk("Egreso registrado correctamente.", "Éxito");
            setModalIsOpen(false);
            ActualizarLista(IngresosEgresosListar, setListaIngresosEgresos);
        } catch (error) {
            mostraAlertaError("Error al guardar.", "Error");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <ModalBootstrap
            titulo="Registrar nuevo egreso de caja"
            modalIsOpen={modalIsOpen}
            setModalIsOpen={setModalIsOpen}
            nombreBoton="Nuevo egreso"
            estiloBoton="btn btn-warning text-dark mx-2"
            iconBoton="fas fa-minus-circle me-2"
            pie={
                <button className="btn btn-warning text-dark" onClick={handleGuardar} disabled={isLoading || !cajaId}>
                    Guardar {isLoading ? <span className="spinner-border spinner-border-sm ms-2"></span> : <i className="fas fa-save ms-2"></i>}
                </button>
            }
        >
            <form>
                <div className="mb-4 border-bottom pb-3 d-flex justify-content-between align-items-center">
                    <p className="text-muted mb-0"><i className="far fa-calendar-alt me-2"></i><strong>{moment(formulario.fecha).format("DD [de] MMMM [de] YYYY")}</strong></p>
                    <span className="badge bg-danger fs-6">{formulario.tipo}</span>
                </div>
                <div className="mb-3">
                    <label className="form-label fw-bold">Notas/Detalles</label>
                    <textarea id="notas" className="form-control" rows="2" value={formulario.notas} onChange={handleInputChange} maxLength={150}></textarea>
                </div>

                <MetodosPagos
                    efectivo={efectivo}
                    setEfectivo={setEfectivo}
                    montosPos={montosPos}
                    setMontosPos={setMontosPos}
                    referenciasPos={referenciasPos}
                    setReferenciasPos={setReferenciasPos}
                    erroresReferenciaPos={erroresReferenciaPos}
                    setErroresReferenciaPos={setErroresReferenciaPos}
                    montosTransferencia={montosTransferencia}
                    setMontosTransferencia={setMontosTransferencia}
                    referenciasTransferencia={referenciasTransferencia}
                    setReferenciasTransferencia={setReferenciasTransferencia}
                    erroresReferenciaTransferencia={erroresReferenciaTransferencia}
                    setErroresReferenciaTransferencia={setErroresReferenciaTransferencia}
                    pos={pos}
                    setPos={setPos}
                    transferencias={transferencias}
                    setTransferencias={setTransferencias}
                    formatoMoneda={formatoMoneda}
                    totalConRecargo={0}
                    totalRecibido={parseFloat(efectivo || 0) + pos + transferencias}
                />
                {!cajaId && <div className="alert alert-danger mt-3">Caja no disponible.</div>}
            </form>
        </ModalBootstrap>
    );
};

export default ModalEgreso;